
import { PERMANENCIA_PLAN_CORPORATIVO_CHOICE, TIPO_PLAN_CORPORATIVO_CHOICE } from '@/shared/interfaces';
import * as yup from 'yup';

////*Prospecto
export const PlanCorporativoSchema = yup.object({
  
  nombre: yup.string().required('Campo Requerido').typeError('Campo Requerido'),
  tipo_plan: yup.string().required('Campo Requerido').typeError('Campo Requerido')
    .oneOf(TIPO_PLAN_CORPORATIVO_CHOICE, 'Método de pago no válido'),
  permanencia: yup.string().required('Campo Requerido').typeError('Campo Requerido')
    .oneOf(PERMANENCIA_PLAN_CORPORATIVO_CHOICE, 'Método de pago no válido'),
  costo_instalacion: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  valor: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  capacidad: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
});

